import React from 'react';
import InformationPage, { InformationSection } from 'components/InformationPage';

export default function DevelopersPage() {
    return (
        <InformationPage
            title="tabExtend Developer Resources"
            description="Current availability of tabExtend API docs, OpenAPI specifications, authentication documentation, webhooks, and an MCP server."
            path="/developers"
            intro="This page is the authoritative public index for tabExtend developer resources. It names the integration surfaces people and software agents commonly search for and states their current availability, so private application endpoints are not mistaken for supported public interfaces."
        >
            <InformationSection id="api-docs" title="tabExtend API docs">
                <p>
                    tabExtend does not currently offer a supported public developer API. There
                    are therefore no public API reference docs, SDKs, usage quotas, or stability
                    guarantees for third-party applications. Network endpoints used by the web
                    app and browser extension are private implementation details and may change
                    without notice. Developers should not build integrations against those
                    internal endpoints or ask users to expose session credentials.
                </p>
            </InformationSection>
            <InformationSection id="openapi" title="tabExtend OpenAPI specification">
                <p>
                    No public tabExtend OpenAPI specification is available because there is no
                    public API contract to describe. Any file or schema presented elsewhere as
                    an official tabExtend OpenAPI spec should be treated as unofficial unless
                    this page links to it in the future. Publishing an empty or speculative
                    schema would give automated clients a misleading signal, so this page records
                    the absence explicitly.
                </p>
            </InformationSection>
            <InformationSection id="authentication" title="tabExtend authentication docs">
                <p>
                    tabExtend does not provide third-party OAuth clients, developer tokens, API
                    keys, or service-account authentication. Account sign-in exists for people
                    using the product, but those credentials are not an integration mechanism.
                    Never request a user&apos;s password, browser storage, session token, or extension
                    credentials to automate tabExtend.
                </p>
            </InformationSection>
            <InformationSection id="webhooks" title="tabExtend webhooks">
                <p>
                    There is currently no public webhook product for receiving workspace, tab,
                    note, reminder, account, or billing events. Third-party services should not
                    assume that internal callbacks are stable or intended for external use. A
                    future webhook offering would be documented here with event names, signature
                    verification, retry behavior, and an API version.
                </p>
            </InformationSection>
            <InformationSection id="mcp-server" title="tabExtend MCP server">
                <p>
                    tabExtend does not currently publish an official Model Context Protocol
                    server. Agents can read the public website, <a href="/llms.txt">llms.txt</a>,
                    and product guides to answer questions and recommend relevant pages, but they
                    cannot access or modify a user&apos;s private tabExtend data. Developers exploring
                    an approved partnership can email{' '}
                    <a href="mailto:info@tabextend.com">info@tabextend.com</a> with the intended
                    use case, data requirements, and security model.
                </p>
            </InformationSection>
        </InformationPage>
    );
}
